// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-bar":"AltZr","rc-tabs-tab":"PG0xO","rc-tabs-tab-active":"_0XET6","tip":"PWj+Z","tip-label":"oJRk4","tip-group":"jfmNz","empty":"jOQKF","message":"_5MRoq"};